import chartTypes from "../types/chart";

function radarChartData(payload) {
  return {
    type: chartTypes.RADAR_CHART_DATA,
    payload,
  };
}

function radarChartDataSuccess(payload) {
  return {
    type: chartTypes.RADAR_CHART_DATA_SUCCESS,
    payload,
  };
}

function radarChartDataFailure(payload) {
  return {
    type: chartTypes.RADAR_CHART_DATA_FAILURE,
    payload,
  };
}

const chart = {
  radarChartData,
  radarChartDataSuccess,
  radarChartDataFailure,
};

export default chart;
